export const routes = {
  SIGN_IN: "/sign-in",
  CREATE_GOAL: "/create-goal.html",
  AUTH: "/auth",
  AUTH_CALLBACK: "/auth/callback",
  GOALS: "/view-goals.html",
  GOAL: "/goal/:action/:id",
};
